// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606142351/js/" + chunkId + "." + {"44":"ac086510","225":"514c9b73","481":"1c8a7c30","486":"3bdd490b","770":"f602b9ed"}[chunkId] + ".0.7358538287239978.chunk.js";
};